import { PermissionList } from '@/libs/defaultList';

export default [
    // *===============================================---*
    // *--------- HR Management  ---- ---------------------------------------*
    // *===============================================---*
    //#region Employee
    {
        path: '/hrmanagement/Employees',
        name: 'employee-listing',
        component: () => import('@/views/hrmanagement/EmployeeManagement/EmployeeListing.vue'),
        meta: {
            pageTitle: 'Employee',
            breadcrumb: [
                {
                    text: 'Employees',
                    active: true,
                },
            ], 
            permissions: PermissionList.HRMS_View
        },
    },
    {
        path: '/hrmanagement/Employee',
        name: 'add-employee',
        component: () => import('@/views/hrmanagement/EmployeeManagement/EmployeeDetails/EmployeeDetails.vue'),
        meta: {
            pageTitle: 'New Employee',
            isEdit: true,
            breadcrumb: [
                {
                    text: 'Employees',
                    to: '/hrmanagement/Employees',
                },
                {
                    text: 'New Employee',
                    active: true,
                },
            ], 
            permissions: PermissionList.HRMS_Create
        },
    },
    {
        path: '/hrmanagement/View/Employee/:id',
        name: 'view-employee',
        component: () => import('@/views/hrmanagement/EmployeeManagement/EmployeeDetails/EmployeeDetails.vue'),
        meta: {
            pageTitle: 'View Employee',
            isEdit: false,
            breadcrumb: [
                {
                    text: 'Employees', 
                    to: '/hrmanagement/Employees',
                },
                {
                    text: 'View Employee',
                    active: true,
                },
            ],
            permissions: PermissionList.HRMS_View
        },
    },
    {
        path: `/hrmanagement/Edit/Employee/:id`,
        name: 'edit-employee',
        component: () => import('@/views/hrmanagement/EmployeeManagement/EmployeeDetails/EmployeeDetails.vue'),
        meta: {
            pageTitle: 'Edit Employee',
            isEdit: false,
            breadcrumb: [
                {
                    text: 'Employees',
                    to: '/hrmanagement/Employees',
                },
                {
                    text: 'Edit Employee',
                    active: true,
                },
            ], 
            permissions: PermissionList.HRMS_Update
        },
    },
    //#endregion

    // {
    //     path: '/hrmanagement/WorkForceTracking/workforce-traking',
    //     name: 'workforce-tracking',
    //     component: () => import('@/views/hrmanagement/WorkForceTracking/WorkForceTracking.vue'),
    //     meta: {
    //         pageTitle: 'WorkForce Tracking',
    //         breadcrumb: [
    //             {
    //                 text: 'WorkForce Tracking',
    //                 active: true,
    //             },
    //         ], 
    //     },
    // },
    {
        path: '/hrmanagement/PayrollManagement/payroll-listing',
        name: 'payroll-listing',
        component: () => import('@/views/hrmanagement/PayrollManagement/PayrollListing.vue'),
        meta: {
            pageTitle: 'Payroll',
            breadcrumb: [
                {
                    text: 'Payroll List',
                    active: true,
                },
            ],
            permissions: PermissionList.HRMS_Create
        },
    },

    {
        path: '/hrmanagement/PayrollManagement/payroll-employee',
        name: 'payroll-employee',
        component: () => import('@/views/hrmanagement/PayrollManagement/EmployeePayroll.vue'),
        meta: {
            pageTitle: 'Payroll',
            breadcrumb: [
                {
                    text: 'Payroll',
                    active: true,
                },
            ],
            permissions: PermissionList.HRMS_View
        },
    },

    {
        path: '/hrmanagement/PayrollManagement/payroll-view/:id/:allocationDate',
        name: 'payroll-view',
        component: () => import('@/views/hrmanagement/PayrollManagement/ViewPayroll/ViewPayroll.vue'),
        meta: {
            pageTitle: 'Payroll',
            breadcrumb: [
                {
                    text: 'Payroll List',
                    active: true,
                },
            ],
            permissions: PermissionList.HRMS_Create
        },
    },

    //Employee Allocation
    {
        path: '/hrmanagement/Allocations',
        name: 'employeeallocation-listing',
        component: () => import('@/views/hrmanagement/Allocations/EmployeeAllocationListing.vue'),
        meta: {
            pageTitle: 'Employee Allocation',
            breadcrumb: [
                {
                    text: 'Employee Allocation',
                    active: true,
                },
            ],
            permissions: PermissionList.HRMS_Create
        },
    },
    {
        path: '/hrmanagement/Allocations/AddAllocation/add-allocation',
        name: 'add-allocation',
        component: () => import('@/views/hrmanagement/Allocations/AddAllocation/AddAllocation.vue'),
        meta: {
            pageTitle: 'Add Allocation',
            isEdit: false,
            breadcrumb: [
                {
                    text: 'Add Allocation',
                    active: true,
                },
            ],
            permissions: PermissionList.HRMS_Create
        },
    },
    {
        path: '/hrmanagement/Allocations/:id',
        name: 'view-allocation',
        component: () => import('@/views/hrmanagement/Allocations/AddAllocation/AddAllocation.vue'),
        meta: {
            pageTitle: 'Edit Allocation',
            isEdit: false,
            breadcrumb: [
                {
                    text: 'Edit Allocation',
                    active: true,
                },
            ],
            permissions: PermissionList.HRMS_Create
        },
    },
    {
        path: '/hrmanagement/Allocations/:id',
        name: 'edit-allocation',
        component: () => import('@/views/hrmanagement/Allocations/AddAllocation/AddAllocation.vue'),
        meta: {
            pageTitle: 'Edit Allocation',
            isEdit: true,
            breadcrumb: [
                {
                    text: 'Edit Allocation',
                    active: true,
                },
            ],
            permissions: PermissionList.HRMS_Create
        },
    },
    
    {
        path: '/hrmanagement/EmployeeManagement/department-listing',
        name: 'department-listing',
        component: () => import('@/views/hrmanagement/EmployeeManagement/DepartmentListing.vue'),
        meta: {
            pageTitle: 'Department',
            breadcrumb: [
                {
                    text: 'Department List',
                    active: true,
                },
            ],
            permissions: PermissionList.HRMS_Create
        },
    },
    {
        path: '/hrmanagement/EmployeeManagement/designation-listing',
        name: 'designation-listing',
        component: () => import('@/views/hrmanagement/EmployeeManagement/DesignationListing.vue'),
        meta: {
            pageTitle: 'Designation',
            breadcrumb: [
                {
                    text: 'Designation List',
                    active: true,
                },
            ], 
            permissions: PermissionList.HRMS_Create
        },
    },
    {
        path: '/hrmanagement/LeaveManagement/leave-request',
        name: 'leave-request',
        component: () => import('@/views/hrmanagement/LeaveManagement/LeaveRequest.vue'),
        meta: {
            pageTitle: 'Leave Request',
            breadcrumb: [
                {
                    text: 'Leave Request',
                    active: true,
                },
            ], 
        },
    },
    {
        path: '/hrmanagement/LeaveManagement/leave-types',
        name: 'leave-types',
        component: () => import('@/views/hrmanagement/LeaveManagement/LeaveTypes.vue'),
        meta: {
            pageTitle: 'Leave Types',
            breadcrumb: [
                {
                    text: 'Leave Types',
                    active: true,
                },
            ],
            permissions: PermissionList.HRMS_Create
        },
    },
    {
        path: '/hrmanagement/LeaveManagement/leave-approval',
        name: 'leave-approval',
        component: () => import('@/views/hrmanagement/LeaveManagement/LeaveApproval.vue'),
        meta: {
            pageTitle: 'Leave Approval',
            breadcrumb: [
                {
                    text: 'Leave Approval',
                    active: true,
                },
            ], 
        },
    },
    {
        path: '/hrmanagement/LeaveManagement/leave-balance',
        name: 'leave-balance',
        component: () => import('@/views/hrmanagement/LeaveManagement/LeaveBalance.vue'),
        meta: {
            pageTitle: 'Leave Balance',
            breadcrumb: [
                {
                    text: 'Leave Balance',
                    active: true,
                },
            ], 
        },
    },
    {
        path: '/hrmanagement/LeaveManagement/events-listing',
        name: 'events-listing',
        component: () => import('@/views/hrmanagement/LeaveManagement/EventsListing.vue'),
        meta: {
            pageTitle: 'Events',
            breadcrumb: [
                {
                    text: 'Events List',
                    active: true,
                },
            ], 
        },
    },
    {
        path: '/hrmanagement/PerformanceManagement/performance-listing',
        name: 'performance-listing',
        component: () => import('@/views/hrmanagement/PerformanceManagement/PerformanceListing.vue'),
        meta: {
            pageTitle: 'Rewards',
            breadcrumb: [
                {
                    text: 'Reward List',
                    active: true,
                },
            ], 
        },
    },
    {
        path: '/hrmanagement/TimesheetManagement/timesheet-listing',
        name: 'timesheet-listing',
        component: () => import('@/views/hrmanagement/TimesheetManagement/TimesheetListing.vue'),
        meta: {
            pageTitle: 'Timesheet',
            breadcrumb: [
                {
                    text: 'Timesheet List',
                    active: true,
                },
            ], 
        },
    },
    {
        path: '/hrmanagement/TimesheetManagement/timesheet-approval',
        name: 'timesheet-approval',
        component: () => import('@/views/hrmanagement/TimesheetManagement/TimesheetApproval.vue'),
        meta: {
            pageTitle: 'Timesheet',
            breadcrumb: [
                {
                    text: 'Timesheet List',
                    active: true,
                },
            ], 
        },
    },
    {
        path: '/hrmanagement/TimesheetManagement/approved-timesheet-listing',
        name: 'approved-timesheet-listing',
        component: () => import('@/views/hrmanagement/TimesheetManagement/ApprovedTimesheetListing.vue'),
        meta: {
            pageTitle: 'Approved Timesheet',
            breadcrumb: [
                {
                    text: 'Approved Timesheet List',
                    active: true,
                },
            ], 
        },
    },
    {
        path: '/hrmanagement/TimesheetManagement/rejected-timesheet-listing',
        name: 'rejected-timesheet-listing',
        component: () => import('@/views/hrmanagement/TimesheetManagement/RejectedTimesheetListing.vue'),
        meta: {
            pageTitle: 'Rejected Timesheet',
            breadcrumb: [
                {
                    text: 'Rejected Timesheet Listing',
                    active: true,
                },
            ], 
        },
    },
    {
        path: '/hrmanagement/AttendanceManagement/workforce-tracking',
        name: 'workforce-tracking',
        component: () => import('@/views/hrmanagement/AttendanceManagement/WorkforceTracking.vue'),
        meta: {
            pageTitle: 'Workforce Tracking',
            breadcrumb: [
                {
                    text: 'Workforce Tracking',
                    active: true,
                },
            ], 
        },
    },
    {
        path: '/hrmanagement/AttendanceManagement/attendance-listing',
        name: 'attendance-listing',
        component: () => import('@/views/hrmanagement/AttendanceManagement/AttendanceListing.vue'),
        meta: {
            pageTitle: 'Attendance',
            breadcrumb: [
                {
                    text: 'Attendance List',
                    active: true,
                },
            ], 
        },
    },
    {
        path: '/hrmanagement/report',
        name: 'report',
        component: () => import('@/views/hrmanagement/report.vue'),
        meta: {
            pageTitle: 'Report',
            breadcrumb: [
                {
                    text: 'Report',
                    active: true,
                },
            ],
            permissions: PermissionList.HRMS_Create
        },
    },
]